import Avvir from "avvir";

import getScanDatasetFilesForProjectByScanDatasetId from "../../../services/getters/file_getters/get_scan_dataset_files_for_project_by_scan_dataset_id";
import scanDatasetFilesForProjectLoaded, { ScanDatasetFilesForProjectLoadedEvent } from "../../../events/loaded/scan_datasets/scan_dataset_files_for_project_loaded";
import { AvvirAsyncThunk } from "../../make_eventful_action";

const loadScanDatasetFilesForProject = (projectId: string): AvvirAsyncThunk<typeof getScanDatasetFilesForProjectByScanDatasetId, ScanDatasetFilesForProjectLoadedEvent> => {
  return (dispatch, getState) => {
    const user = getState().user;
    return Avvir.api.files.listScanDatasetFilesForProject({ projectId }, user).then((filesByScanDatasetId) => {
      dispatch(scanDatasetFilesForProjectLoaded(filesByScanDatasetId));
      return getScanDatasetFilesForProjectByScanDatasetId(getState(), { projectId });
    });
  };
};

export default loadScanDatasetFilesForProject;
